import { Inject, Injectable } from "@angular/core";
import { BnNgIdleService } from "bn-ng-idle";
import { take } from "rxjs/operators";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { LogoutService } from "@app/services/Logout.service";

@Injectable({ providedIn: "root" })
export class IdleService {

    constructor(@Inject(BnNgIdleService) private idle: BnNgIdleService,
                @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
                @Inject(LogoutService) private logoutService: LogoutService) {}

    init() {
        // time out after 15 minutes
        this.idle.startWatching(900).subscribe((isTimedOut: boolean) => {
            if (isTimedOut) {
                // Start Idle.watch() again after a timeout occurred
                this.idle.resetTimer();
                this.guestPaymentStore.clearAllGuest()
                this.logoutService.logout();
            }
        });
    }
}
